import { connect } from "react-redux";
import { ListView as Component, ListViewProps } from "./ListView.component";
import { RootState } from "../../../../reducers";
import {
  getCustomTowToDestinationList,
  getNearbyDestinationError,
  getNearbyDestinations,
  getNearbyPlaces,
  getPartnerCode,
  getPartnerPhoneNumber,
} from "../../../../selector";
import { PEP } from "../../../../app-consts/appConstants";
import { requestAdditionalNearByDestinationsForDropdown } from "../../../../action";

const mapStateToProps = (state: RootState) =>
  ({
    customerServicePhoneNumber: getPartnerPhoneNumber(state),
    destinations: getNearbyDestinations(state).destinations,
    isPep: getPartnerCode(state) === PEP,
    nearbyDestinationError: getNearbyDestinationError(state),
    partnerCode: getPartnerCode(state),
    placesCount: getNearbyPlaces(state)?.length || 0,
    towToDestinations: getCustomTowToDestinationList(state),
  } as Pick<
    ListViewProps,
    | "customerServicePhoneNumber"
    | "destinations"
    | "isPep"
    | "nearbyDestinationError"
    | "partnerCode"
    | "placesCount"
    | "towToDestinations"
  >);

export const ListView = connect(mapStateToProps, {
  onClick: requestAdditionalNearByDestinationsForDropdown,
} as Pick<ListViewProps, "onClick">)(Component);
